import BaseApiService from './BaseApiService'
import type { AuditEvent } from '../types'

class AuditApiService extends BaseApiService {
  list(page = 1, pageSize = 50): Promise<AuditEvent[]> {
    return this.post<AuditEvent[]>('/v1/audit/list', { page, pageSize })
  }

  exportUrl(days = 30): string {
    return `${this.apiBaseUrl}/v1/audit/export?days=${days}`
  }
}

export const auditApiService = new AuditApiService()
